// ============================================================================
// services/scheduleModule/ptpResponseServices.js — new file
// ============================================================================

import { RESPONSE_URLS, PBI_URLS } from "../apiConfig.js";
import { RESPONSE_ERRORS } from "../../common/constants/scheduleModule/responseConstants.js";
import apiClient from "../apiInstance.js";

export const fetchPtpResponseData = async ({ startDate, endDate, responseType }) => {
  try {
    const response = await apiClient.post(RESPONSE_URLS.GET_PTP_RESPONSE, {
      startDate,
      endDate,
      responseType,
    });
    return response.data;
  } catch (error) {
    console.error(RESPONSE_ERRORS.FETCH_RESPONSE_ERROR, error);
    throw error;
  }
};

export const fetchPtpAging = async ({ startDate, endDate, channel, campaign }) => {
    try {
      const params = { startDate, endDate, channel };
      if (campaign && campaign !== "All") params.campaign = campaign;
   
      const response = await apiClient.get(PBI_URLS.DASHBOARD_PTP_AGING, { params });
      return response.data;
    } catch (error) {
      console.error("Error fetching PTP aging:", error);
      throw error;
    }
  };